<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "content4.Guests Announcements" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="restaurantId">
                    <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
                </li>
                <li class="breadcrumb-item">{{"content4.Events & Guests Announcements" | translate}}</li>
                <li class="breadcrumb-item">{{ "content4.Guests Announcements" | translate }}</li>
            </ol>
        </div>
        <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData();"></app-restaurants-dropdown>
    </div>
</nav>
<div class="button-group-custom">
    <mat-button-toggle-group [(ngModel)]="filterModel.announcementStuts" (change)="typeFilter($event)">
        <mat-button-toggle *ngFor="let status of typesListAll" [value]="status.id" [disabled]="dataLoading">
          {{status.name}}
            <ng-container *ngIf="recordsData">
                <span class="count" *ngIf="status.id == 1 && recordsData.totalCountOngoing != 0">{{recordsData.totalCountOngoing}}</span>
                <span class="count" *ngIf="status.id == 0 && recordsData.totalCountPast != 0">{{recordsData.totalCountPast}}</span>
            </ng-container>
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>

<div class="page">
    <div class="page-filters">
        <div class="sort-item">
            <span class="count-page">
                <span>{{recordsData?.totalCount}}</span>
                <ng-container *ngIf="filterModel.announcementStuts == 1">
                    {{ 'content4.Active Announcements' | translate }}
                </ng-container>
                <ng-container *ngIf="filterModel.announcementStuts == 0">
                    {{ 'content4.Past Announcements' | translate }}
                </ng-container>
            </span>
        </div>
        <div class="filters-container">
            <div class="search-input">
                <mat-form-field appearance="legacy" *ngIf="showSearch">
                    <input matInput autocomplete="off" [(ngModel)]="filterModel.searchText"
                        (keydown.enter)="makeSearch()" maxlength="20">
                    <mat-icon (click)="resetSearch(); showSearch = false;" matSuffix>clear</mat-icon>
                </mat-form-field>
                <button mat-icon-button (click)="makeSearch()">
                    <img src="./assets/images/icons/search.svg">
                </button>
            </div>
            <button (click)="showFilter = !showFilter" [ngClass]='{"active": showFilter}' class="btn dropdown-custom">
                <img src="./assets/images/icons/filter-outline.svg">
                <span>{{"general.Filter" | translate}}</span>
                <svg width="8" height="5.001" viewBox="0 0 8 5.001">
                    <path id="menu-icon" d="M-3.562-9.316-.5-6.215l3.062-3.1.938.949-4,4.051-4-4.051Z"
                        transform="translate(4.5 9.316)" fill="#6a6a6a" opacity="0.8" />
                </svg>
            </button>
        </div>

        <div class="filter-section" [hidden]="!showFilter">
            <h4 class="title">{{"general.Filter by" | translate}}</h4>
            <div [formGroup]="filterFormGroup" class="row">
                <div class="col-lg-3 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Date From" | translate}}</mat-label>
                        <input matInput [matDatepicker]="dateFrom" formControlName='dateFrom' [max]="filterFormGroup.controls['dateTo'].value || today"  readonly
                        (focus)="dateFrom.open()" (click)="dateFrom.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['dateFrom'].value"
                            (click)="filterFormGroup.controls['dateFrom'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #dateFrom></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 mb-3">
                    <mat-form-field class="no-validation">
                        <mat-label>{{"forms.Date To" | translate}}</mat-label>
                        <input matInput [matDatepicker]="dateTo" formControlName='dateTo' [min]="filterFormGroup.controls['dateFrom'].value" readonly
                        (focus)="dateTo.open()" (click)="dateTo.open()">
                        <button mat-icon-button matSuffix *ngIf="filterFormGroup.controls['dateTo'].value"
                            (click)="filterFormGroup.controls['dateTo'].setValue(''); makeFilter();">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                        <mat-datepicker #dateTo></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 mb-3">
                    <mat-form-field hideRequiredMarker>
                        <mat-label> {{ 'forms.Time From' | translate }}</mat-label>
                        <input matInput [ngxTimepicker]="timeFrom" [format]="24" readonly formControlName="timeFrom">
                        <div matSuffix class="d-flex align-items-center">
                            <mat-icon matSuffix *ngIf="filterFormGroup.controls['timeFrom'].value"
                                (click)="filterFormGroup.controls['timeFrom'].setValue('')">clear
                            </mat-icon>
                            <ngx-material-timepicker-toggle [for]="timeFrom"></ngx-material-timepicker-toggle>
                        </div>
                        <ngx-material-timepicker #timeFrom></ngx-material-timepicker>
                        <!-- <mat-error *ngIf="hasError('startTime', 'required')">{{ 'forms.Required' | translate }}
                        </mat-error> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 mb-3">
                    <mat-form-field hideRequiredMarker>
                        <mat-label> {{ 'forms.Time To' | translate }}</mat-label>
                        <input matInput [ngxTimepicker]="timeTo" [format]="24" readonly formControlName="timeTo"
                        [min]="filterFormGroup.controls['timeFrom'].value">
                        <div matSuffix class="d-flex align-items-center">
                            <mat-icon matSuffix *ngIf="filterFormGroup.controls['timeTo'].value"
                                (click)="filterFormGroup.controls['timeTo'].setValue('')">clear
                            </mat-icon>
                            <ngx-material-timepicker-toggle [for]="timeTo"></ngx-material-timepicker-toggle>
                        </div>
                        <ngx-material-timepicker #timeTo></ngx-material-timepicker>
                        <!-- <mat-error *ngIf="hasError('startTime', 'required')">{{ 'forms.Required' | translate }}
                        </mat-error> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-4 mb-3">
                    <mat-form-field hideRequiredMarker>
                        <mat-label>{{ 'content4.Companies Number' | translate }}</mat-label>
                        <input matInput formControlName="companionsNumber" appOnlynumber>
                    </mat-form-field>
                </div>
            </div>

            <div class="btn-container">
                <button mat-stroked-button color="primary" (click)="makeFilter()">{{"general.Apply Filter" |
                    translate}}</button>
                <button mat-stroked-button (click)="clearFilter()">{{"general.Clear Filter" | translate}}</button>
            </div>
        </div>
    </div>

    <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>

    <ng-container *ngIf='!dataLoading'>
        <div *ngIf="recordsData?.pageData && recordsData?.pageData?.length; else dataEmpty">

            <div class="table-responsive table-container">
                <table class="table table-primary">
                    <thead>
                        <tr>
                            <th>{{'content.Name' | translate}}</th>
                            <th>{{'content4.Invited (May Come)' | translate}}</th>
                            <th>{{'forms.Date' | translate}}</th>
                            <th>{{'orders.Time' | translate}}</th>
                            <!-- If Owner -->
                            <th *ngIf="recordsData?.userType == 'RestaurantOwnerRole'">{{'content4.Branch' | translate}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.pageData">
                            <td>
                                <div class="name-with-image">
                                    <div class="image-circle">
                                        <span *ngIf="!item.iconAnnouncement">{{ item.nameAnnouncement | shortName }}</span>
                                        <img *ngIf="item.iconAnnouncement" [src]="item.iconAnnouncement" (error)="item.iconAnnouncement = ''">
                                    </div>
                                    <div class="name">
                                        <h5 [matTooltip]="item.nameAnnouncement" class="font-14 fontRegular">
                                            {{item.nameAnnouncement}}</h5>
                                    </div>
                                </div>
                            </td>
                            <td class="font-14 fontRegular">{{item.typeAnnouncement}}</td>
                            <td class="font-14 fontRegular">{{item.dateAnnouncement | date:'d MMM, y'}}</td>

                            <td class="font-14 fontRegular">
                              {{item.timeAnnouncementFrom}}
                              <span *ngIf="item.timeAnnouncementTo" class="grey-color font-14 ml-2 mr-2"> {{ 'content2.to' | translate }}</span>
                              {{item.timeAnnouncementTo}}
                            </td>
                            <td class="font-14 fontRegular" *ngIf="recordsData?.userType == 'RestaurantOwnerRole'">
                                {{item.branchName}}</td>
                            <!-- <td>
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        (click)="openEventForm(item)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                                        (click)="deleteRecord(item.id)">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>

                                </div>
                            </td> -->
                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="pagination-container" *ngIf="recordsData && (pageCount > 1 || recordsData['totalCount'] > pageSize)">
                <mat-paginator [length]="recordsData['totalCount']" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[5, 10, 20]" (page)="getAll($event, restaurantId)" [pageIndex]="filterModel.pageNumber">
                </mat-paginator>
            </div>

        </div>
        <div *ngIf='dataLoading' class="dataLoading py-5">
            <mat-spinner class="m-auto" diameter="50"></mat-spinner>
        </div>
        <!-- <ng-template #dataEmpty>
            <empty-state [title]='"content4.Announcements list is empty" | translate'
                [img]="'/assets/images/icons/announcements-empty.svg'"></empty-state>
        </ng-template> -->

        <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
        </ng-template>
    </ng-container>
</div>
